import axios from '@/api/requests/axios'

export default {
  getAll: params => axios.get('/api/admin/v1/notification-campaigns', { params }),
  getById: id => axios.get(`/api/admin/v1/notification-campaigns/${id}`),
  create: campaign => axios.post('/api/admin/v1/notification-campaigns', campaign),
  update: (id, campaign) => axios.put(`/api/admin/v1/notification-campaigns/${id}`, campaign),
  cancel: id => axios.post(`/api/admin/v1/notification-campaigns/${id}/cancel`),
  sendNow: id => axios.post(`/api/admin/v1/notification-campaigns/${id}/send-now`),
  getRecipients: (id, params) => axios.get(`/api/admin/v1/notification-campaigns/${id}/recipients`, { params }),

  estimate: audience => axios.post('/api/admin/v1/notification-campaigns/estimate', audience),

  previewPhones: file => {
    const formData = new FormData()
    formData.append('file', file)

    return axios.post('/api/admin/v1/push-notifications/preview-phones', formData)
  },
}
